import { useTrans } from "@/translations";

import { useMemo } from "react";

import { twMerge } from "tailwind-merge";

import { getWidthOfText } from "../functions";

const NUMBER_CIRCLE_WIDTH = 26;

type Props = {
  stepKeys: string[];
  activeStepKey: string;
};

export const StepViewer: React.FC<Props> = ({
  stepKeys,
  activeStepKey,
}: Props) => {
  const { t } = useTrans();

  const activeStepIndex = useMemo(
    () => stepKeys.findIndex((key) => key === activeStepKey),
    [stepKeys, activeStepKey],
  );

  return (
    <div className="ml-12 flex w-full pb-4">
      {stepKeys.map((stepKey, i) => {
        const isActive = i <= activeStepIndex;
        const isNotLast = i !== stepKeys.length - 1;

        const title = t(`importLabels:${stepKey}`);
        const textLength = getWidthOfText(title, "normal 14px DM Sans");
        const left = -(textLength - NUMBER_CIRCLE_WIDTH) / 2;

        return (
          <div key={stepKey} className="relative block flex items-center">
            <div
              className={twMerge(
                "relative m-auto flex w-[23px] items-center justify-center rounded-full border border-black text-sm",
                isActive && "border-lime bg-lime",
              )}
            >
              {i + 1}
            </div>
            <div
              className="absolute mt-12 text-sm whitespace-nowrap"
              style={{ left }}
            >
              {t(`importLabels:${stepKey}`)}
            </div>
            {isNotLast && <hr className="mx-4 w-36 border-black" />}
          </div>
        );
      })}
    </div>
  );
};
